import {createContext, useContext} from 'react';

const AppContext = createContext();

export const useApps = () => useContext(AppContext);

export default AppContext;
